// for add employee state
export const ADD_PROFILE_DATA = "add_profile_data";
